module.exports = __webpack_public_path__ + "static/img/11.4a7dccd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/11.png
// module id = Uqxz
// module chunks = 0